import { useTranslate } from '@growtherapy/i18n';
import { Modal, ModalBody, ModalHeader, Text, cn } from '@growtherapy/sprout-ui';

import { MusicStateToggleButtonWrapper as MusicStateToggleButton } from '../background-action/MusicStateToggleButtonWrapper';
import { KeyboardWrapper as Keyboard } from './KeyboardWrapper';
import { KeyConfiguration, OnKeyPlayedFn, VibesComponentProps } from './types';

export function VerticalVibes({
  closePreSessionVibes,
  onKeyPlayed,
  keys,
  bodyClassOverride,
}: VibesComponentProps & {
  onKeyPlayed: OnKeyPlayedFn;
  keys: KeyConfiguration[];
  bodyClassOverride: string;
}) {
  const t = useTranslate();
  return (
    <Modal isOpen onClose={closePreSessionVibes} className='h-full rebrand:bg-surface-inverseEmphasis'>
      <ModalHeader className='[&_button]:rebrand:mobile:text-text-inverse' contentClassName='rebrand:text-text-inverse'>
        {t('telehealth-core:waitingRoom.unwindWhileYouWait')}
      </ModalHeader>
      <ModalBody
        className={cn(
          'flex flex-col justify-center items-center gap-4 h-full w-full overflow-hidden  py-0',
          bodyClassOverride,
        )}
      >
        <div className='flex flex-col justify-center items-center h-full w-full overflow-x-visible overflow-y-visible relative'>
          <Text className='absolute top-1/3 text-center transition-opacity ease-in-ease-out delay-[0s] duration-1000 visible opacity-100 group-[.show-all]/keyboard:opacity-0 group-[.show-all]/keyboard:invisible group-[.show-all]/keyboard:h-0 rebrand:text-text-inverse'>
            {t('telehealth-core:waitingRoom.toMakeMusicTapOnShape')}
          </Text>
          <Keyboard onKeyPlayed={onKeyPlayed} keys={keys} />
        </div>
        <div className='py-2 w-full flex justify-center'>
          <MusicStateToggleButton />
        </div>
      </ModalBody>
    </Modal>
  );
}
